import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { DisclaimerBanner } from '@/components/DisclaimerBanner';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminProtectedRoute } from '@/components/AdminProtectedRoute';
import { GdprBanner } from '@/components/GdprBanner';
import OnboardingModal from '@/components/OnboardingModal';
import HomePage from '@/pages/HomePage';
import QuizPage from '@/pages/QuizPage';
import MyPlanPage from '@/pages/MyPlanPage';
import WalletPage from '@/pages/WalletPage';
import PricingPage from '@/pages/PricingPage';
import FAQPage from '@/pages/FAQPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import TermsPage from '@/pages/TermsPage';
import DisclaimerPage from '@/pages/DisclaimerPage';
import PrivacyPage from '@/pages/PrivacyPage';
import ProfilePage from '@/pages/ProfilePage';
import CheckoutPage from '@/pages/CheckoutPage';
import AdminPage from '@/pages/AdminPage';
import CookbookPage from '@/pages/CookbookPage';
import '@/App.css';

const Layout = ({ children, showBanner = true }) => (
  <div className="min-h-screen flex flex-col bg-[#F7FAFC] dark:bg-[#0c1320] transition-colors duration-300">
    <Header />
    {showBanner && <DisclaimerBanner />}
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/calculator" element={<Layout><QuizPage /></Layout>} />
              <Route path="/my-plan" element={<Layout><ProtectedRoute><MyPlanPage /></ProtectedRoute></Layout>} />
              <Route path="/wallet" element={<Layout><ProtectedRoute><WalletPage /></ProtectedRoute></Layout>} />
              <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
              <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
              <Route path="/login" element={<Layout><LoginPage /></Layout>} />
              <Route path="/register" element={<Layout><RegisterPage /></Layout>} />
              <Route path="/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
              <Route path="/disclaimer" element={<Layout><DisclaimerPage /></Layout>} />
              <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
              <Route path="/profile" element={<Layout><ProtectedRoute><ProfilePage /></ProtectedRoute></Layout>} />
              <Route path="/checkout" element={<Layout><CheckoutPage /></Layout>} />
              <Route path="/cookbook" element={<Layout><ProtectedRoute><CookbookPage /></ProtectedRoute></Layout>} />
              <Route path="/admin" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />
            </Routes>
            <GdprBanner />
            <OnboardingModal />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
